import { StatusAutorizacaoAbsorvente } from 'graphql/types.generated'

export type DignidadeMenstrualStatusAutorizacaoAbsorventeEnum = StatusAutorizacaoAbsorvente
export const DignidadeMenstrualStatusAutorizacaoAbsorventeEnum = StatusAutorizacaoAbsorvente

interface RmsDignidadeMenstrualInput {
  codigo?: string
  uf?: string
}

interface CidadaoDignidadeMenstrualInput {
  cns?: string
  dataNascimento?: string
  nome?: string
  nomeMae?: string
}

export interface AutorizacaoRetiradaAbsorventesInput {
  cidadaoId: ID
  cidadaoDignidadeMenstrualInput: CidadaoDignidadeMenstrualInput
  rmsDignidadeMenstrualInput: RmsDignidadeMenstrualInput
  hashDocumento?: string
}

export const dignidadeMenstrualStatusMessages: Partial<Record<
  DignidadeMenstrualStatusAutorizacaoAbsorventeEnum,
  string
>> = {
  [DignidadeMenstrualStatusAutorizacaoAbsorventeEnum.NAO_PERMITIDO]: 'Cidadão não atende aos critérios do programa.',
  [DignidadeMenstrualStatusAutorizacaoAbsorventeEnum.ERRO]:
    'Não foi possível verificar se o cidadão atende aos critérios do programa. Tente novamente mais tarde.',
}
